import React, { ReactNode, useState } from 'react';
import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout';
import { RoutableMenu } from '../RoutableMenu';
import Sider from 'antd/lib/layout/Sider';
import { Grid, Menu } from 'antd';
import { RouterLayoutProps } from '../Router';
const { useBreakpoint } = Grid;

export interface ISiderProps {
  topContent?: ReactNode;
  theme?: 'light' | 'dark';
  mode?: React.ComponentProps<typeof Menu>['mode'];
}

export interface SideNavLayoutProps extends RouterLayoutProps {
  headerContent?: ReactNode;
  footerContent?: ReactNode;
  siderProps?: ISiderProps;
}

export const SideNavLayout: React.FC<SideNavLayoutProps> = (props) => {
  let screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  return (
    <div style={{ height: '100vh' }}>
      <Layout style={{ minHeight: '100%' }}>
        <Sider
          collapsible
          collapsedWidth={screens['xs'] ? 0 : undefined}
          breakpoint="md"
          collapsed={collapsed}
          onCollapse={onCollapse}
          zeroWidthTriggerStyle={{
            position: 'absolute',
            top: '0%',
          }}
          theme={props.siderProps?.theme}
        >
          {props.siderProps?.topContent}
          <RoutableMenu
            collapsed={collapsed}
            pages={props.pages}
            mode={props.siderProps?.mode}
            theme={props.siderProps?.theme}
            onSelect={() => screens['xs'] && setCollapsed(true)}
          ></RoutableMenu>
        </Sider>
        <Layout>
          <Header
            style={{
              padding: 0,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {props.headerContent}
          </Header>
          <Content>{props.children}</Content>
          <Footer style={{ textAlign: 'center' }}>{props.footerContent}</Footer>
        </Layout>
      </Layout>
    </div>
  );
};
